const SUPPORTED_OCR_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg']
const SUPPORTED_OCR_MIME_TYPES = ['image/png', 'image/jpeg', 'application/pdf']

export const supportsOcr = (docType: string) => {
  const type = docType?.toLowerCase() || ''

  if (SUPPORTED_OCR_MIME_TYPES.includes(type)) {
    return true
  }

  let extension = type
  if (type.includes('.')) {
    const parts = type.split('.')
    extension = parts[parts.length - 1]
  } else if (type.startsWith('.')) {
    extension = type.slice(1)
  }

  return SUPPORTED_OCR_EXTENSIONS.includes(extension)
}
